var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.list.length != 0,
          expression: "list.length!=0"
        }
      ],
      staticClass: "aside-1"
    },
    [
      _c("dl", [
        _c("div", { staticClass: "title" }, [
          _c("i"),
          _vm._v(_vm._s(_vm.title))
        ])
      ]),
      _vm._v(" "),
      _vm._l(_vm.list, function(item, index) {
        return _c("dd", [
          _c("i"),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: item.open_type == 0 ? "/news/" + item.id : item.third_url
              }
            },
            [_vm._v(_vm._s(item.title))]
          ),
          _c("span", [_vm._v(_vm._s(_vm.friendlyTime(item.released_at)))])
        ])
      }),
      _vm._v(" "),
      _c("span")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-600714c5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-600714c5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/web/component/web/news-aside/index.vue
// module id = null
// module chunks = 